export function RedAsterisk() {
	return <span className="text-danger">*</span>;
}
